import { LoadingButton } from '@mui/lab';
import { Box, Button, Grid } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { GeneralSelectMenu } from 'src/components/general';
import { FormProvider } from 'src/components/hook-form';
import { COMMENT_LIST } from 'src/constants/queryKeys';
import { networkUpdateComment } from 'src/network/comment';
import useFormsModalStore from 'src/store/forms';

const commentStatusList = [
  { title: 'در انتظار تایید', id: 1 },
  { title: 'تایید شده', id: 2 },
  { title: 'لو دادن داستان', id: 3 },
  { title: 'عدم تایید - رعایت نکردن ادب', id: 4 },
];

const CommentForm = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const { modal, closeModal } = useFormsModalStore();

  const [selectedCommentStatus, setSelectedCommentStatus] = useState('');

  const commentDetails = modal?.data;

  const methods = useForm({});

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  // ---------------------------------------------------------------

  const onSubmit = async () => {
    const PAYLOAD = {
      CommentStatus: selectedCommentStatus,
    };

    try {
      const res = await networkUpdateComment(commentDetails?.CommentID, PAYLOAD);

      if (res?.data?.items?.ResultID === 0) {
        enqueueSnackbar('مشکلی پیش آمده، لطفا مجددا امتحان کنید', { variant: 'error' });
      } else {
        enqueueSnackbar('وضعیت نظر موردنظر بروزرسانی شد');
        await queryClient.invalidateQueries({ queryKey: [COMMENT_LIST] });
      }

      closeModal();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setSelectedCommentStatus(commentDetails?.CommentCommentStatusID || commentStatusList[0]?.id);
  }, []);

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ p: 3 }}>
            <Box
              sx={{
                rowGap: 3,
                columnGap: 2,
                display: 'grid',
                gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
              }}
            >
              <GeneralSelectMenu
                label="وضعیت نظر"
                name="CommentStatus"
                options={commentStatusList}
                value={selectedCommentStatus}
                onChangeValue={setSelectedCommentStatus}
              />

              <div className="flex items-center w-full gap-4">
                <LoadingButton sx={{ width: '100%', height: '100%' }} type="submit" variant="contained" name="save" loading={isSubmitting}>
                  ذخیره
                </LoadingButton>
                <Button
                  sx={{ width: '100%', height: '100%' }}
                  onClick={closeModal}
                  variant="outlined"
                  color="error"
                  disabled={isSubmitting}
                >
                  انصراف
                </Button>
              </div>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </FormProvider>
  );
};

export default CommentForm;
